export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Notifications.vue?vue&type=template&id=1c25355a&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Notifications.vue?vue&type=template&id=1c25355a&
// module id = null
// module chunks = 